




























import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class SubmissionFormComment extends Vue {
  @PropSync("comment", { type: String }) syncedComment!: string;
  @Prop() statementsUnchecked!: boolean;
}
